module.exports = __webpack_public_path__ + "img/cart_mixed.a455dfac.png";